import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon, ArrowUpRightIcon } from "lucide-react";
import { needs } from "../data/needs";
export function Needs() {
  const [activeId, setActiveId] = useState(needs[0].id);
  const active = needs.find(n => n.id === activeId) ?? needs[0];
  const ActiveIcon = active.icon;
  return <section id="besoins" className="w-full bg-white py-24 lg:py-32" data-id="element-131" data-mp="21mt07xt6jyt9">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-132" data-mp="21mkmk3p8gph0">
        <div className="max-w-2xl" data-id="element-133" data-mp="26l4a28jh69bh">
          <h2 className="font-serif text-4xl font-medium text-ink lg:text-5xl" data-id="element-134" data-mp="26k2kz05mjmar">À chaque besoin, sa solution</h2>
          <p className="mt-4 text-lg text-muted" data-id="element-135" data-mp="2bivy2rh01bae">
            Placement ou investissement : identifiez votre objectif, nous construisons la stratégie.
          </p>
        </div>

        <div className="mt-14 grid gap-10 lg:grid-cols-12" data-id="element-136" data-mp="h8k00kt4xibm">
          <ul role="tablist" aria-orientation="vertical" className="border-t border-line lg:col-span-6" data-id="element-137" data-mp="l815vfch4hhb">
            {needs.map(need => {
            const isActive = need.id === activeId;
            return <li key={need.id} className="border-b border-line" data-id="element-138" data-mp="1ipu0kq2kco76">
                  <button type="button" role="tab" aria-selected={isActive} aria-controls="need-panel" onClick={() => setActiveId(need.id)} onMouseEnter={() => setActiveId(need.id)} className="group flex w-full items-center justify-between gap-6 py-5 text-left" data-id="element-139" data-mp="1driqqfc9qdoy">
                    <span className={`font-serif text-2xl transition-colors duration-150 lg:text-[28px] ${isActive ? "text-brand" : "text-ink/70 group-hover:text-ink"}`} data-id="element-140" data-mp="1wh8nv93i7bk1">
                      {need.title}
                    </span>
                    <ArrowRightIcon className={`h-5 w-5 shrink-0 transition-[transform,color] duration-150 ${isActive ? "translate-x-0 text-brand" : "-translate-x-1 text-line"}`} data-id="element-141" data-mp="g2gvuxa9s6b9" />
                  </button>
                </li>;
          })}
          </ul>

          <div id="need-panel" role="tabpanel" className="lg:col-span-6" data-id="element-142" data-mp="2zacozy1qfi1e">
            <div className="relative h-full min-h-[360px] overflow-hidden rounded-2xl bg-brand p-8 text-white lg:p-12" data-id="element-143" data-mp="2klzvr8u14dal">
              <AnimatePresence mode="wait" data-id="element-144" data-mp="2pd85k5z9u0oa">
                <motion.div key={active.id} initial={{
                opacity: 0,
                y: 8
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -8
              }} transition={{
                duration: 0.18,
                ease: [0.23, 1, 0.32, 1]
              }} className="flex h-full flex-col" data-id="element-145" data-mp="2pdznidzy3zw3">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-white/10" data-id="element-146" data-mp="26mqcg0aj132e">
                    <ActiveIcon className="h-6 w-6" data-id="element-147" data-mp="1mzn7mo625u1o" />
                  </span>
                  <h3 className="mt-8 font-serif text-3xl font-medium" data-id="element-148" data-mp="1iz38jf1xcgcw">{active.lead}</h3>
                  <p className="mt-4 max-w-md text-lg leading-relaxed text-white/80" data-id="element-149" data-mp="1wyl2e8u2ujt4">{active.body}</p>
                  <a href="#contact" className="mt-auto inline-flex w-fit items-center gap-2 border-b border-white/40 pb-1 pt-10 text-sm font-semibold transition-colors duration-150 hover:border-white" data-id="element-150" data-mp="1rzhxqpi0eflo">
                    En savoir plus
                    <ArrowUpRightIcon className="h-4 w-4" data-id="element-151" data-mp="2fp2rm3fpax9q" />
                  </a>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </section>;
}